import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationENG from "./locales/en/translation.json";
import translationGr from "./locales/gt/translation.json";

const resources = {
  gt: {
    translation: translationGr,
  },
  eng: {
    translation: translationENG,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");

if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "eng");
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "eng",
    fallbackLng: "eng",

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
